export default __webpack_public_path__ + "static/media/transmetteurPresion.67b37ace.jpg";